import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';

import {
  BooleanGeneralResponse,
  CreateFundManagerDto,
  UpdateFundManagerDto,
  GetFundManagerByEmailOutputDto,
  UserDto,
  UserDtoGeneralResponse,
  UserDtoPaginatedListGeneralResponse,
  FundManagerDto,
} from '../../data-models/identity.data.models';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { GeneralResponse } from 'src/app/shared/shared-data-models';

@Injectable({ providedIn: 'root' })
export class FundManagerDataService {
  private controllerUrl: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/FundManagers/`;

  constructor(private baseApiService: BaseApiService<any>) {}

  getAllFundManagers(
    fullName: string | undefined,
    email: string | undefined,
    phoneNumber: string | undefined,
    nationalId: string | undefined,
    pageIndex?: number | undefined,
    pageSize?: number | undefined
  ): Observable<UserDtoPaginatedListGeneralResponse> {
    return this.baseApiService.Get(
      `${this.controllerUrl}GetAllFundManagers?FullName=${fullName}&Email=${email}&phoneNumber=${phoneNumber}&NationalId=${nationalId}&pageIndex=${pageIndex}&pageSize=${pageSize}`
    );
  }
 
  getFundManagerByEmail(
    email: string
  ): Observable<GeneralResponse<GetFundManagerByEmailOutputDto>> {
    return this.baseApiService.Post(
      `${this.controllerUrl}GetFundManagerByEmail?email=${email}`
    );
  }
  createFundManager(
    body: CreateFundManagerDto
  ): Observable<UserDtoGeneralResponse> {
    return this.baseApiService.Post(
      `${this.controllerUrl}CreateFundManager`,
      body
    );
  }
  updateFundManager(
    body: UpdateFundManagerDto
  ): Observable<UserDtoGeneralResponse> {
    return this.baseApiService.Put(
      `${this.controllerUrl}UpdateFundManager`,
      body
    );
  }
  activateFundManager(body: UserDto): Observable<UserDtoGeneralResponse> {
    return this.baseApiService.Put(
      `${this.controllerUrl}ActivateFundManager`,
      body
    );
  }
  deleteFundManager(id: string): Observable<BooleanGeneralResponse> {
    return this.baseApiService.Delete(
      `${this.controllerUrl}DeleteFundManager?id=${id}`
    );
  }
}
